/**
 * La ruta de las edge functions y la región de la base, en UN solo lugar y sin tocar el cliente.
 *
 * 🚨 LA BASE VIVE SÓLO EN `us-west-2`; Supabase corre cada función en la región más cercana A QUIEN
 * LA LLAMA. Una función que consulta la base desde São Paulo paga el viaje a Oregón en cada
 * consulta: 1710 ms contra 625 ms medidos el 09-sep. Fijar la región en la URL
 * (`forceFunctionRegion`) es lo que lo evita, y vale para CUALQUIER llamador: el panel, un script,
 * y también un cliente MCP de escritorio al que se le entrega la URL para pegar.
 *
 * 🪤 ESTE ES EL ÚNICO ARCHIVO DONDE SE ESCRIBE `/functions/v1/`. `src/lib/supabase.ts` lo usa para
 * el cliente y para `fetchDeFuncion`; `limpieza:gate` cuenta cualquier otra aparición como una
 * llamada que se saltea la región. Es puro —sin `import.meta.env`— para poder probarse sin la
 * base configurada.
 */

export const REGION_DE_LA_BASE = 'us-west-2';

const RUTA_DE_LAS_FUNCIONES = '/functions/v1/';

/** Si esta URL apunta a una edge function (y por lo tanto le importa la región). */
export function esUrlDeFuncion(url: string): boolean {
  return url.includes(RUTA_DE_LAS_FUNCIONES);
}

/** La misma URL con la región de la base fija. Si ya la trae, no se toca. */
export function conLaRegionFija(url: string): string {
  if (!esUrlDeFuncion(url) || url.includes('forceFunctionRegion=')) return url;
  const u = new URL(url);
  u.searchParams.set('forceFunctionRegion', REGION_DE_LA_BASE);
  return u.toString();
}

/** La URL de una edge function, con la región de la base fija, a partir de la URL de Supabase. */
export function urlDeFuncion(supabaseUrl: string, nombre: string): string {
  return conLaRegionFija(`${String(supabaseUrl ?? '').replace(/\/+$/, '')}${RUTA_DE_LAS_FUNCIONES}${nombre}`);
}
